import React, { useState } from 'react'
import { useHistory } from 'react-router'
import { Button, Spinner } from 'react-bootstrap'

import { MonitoringStatus } from 'enum'
import { useTranslationRankmi } from 'helpers/translations.helper'
import restartCourse from 'api/courses/Restart'
import { ICardEnrol } from '../../types'

interface IButtonProps {
  courseId: number | string
  advance: ICardEnrol['advance']
  approved: ICardEnrol['approved']
}

export const RestartCourse: React.FC<IButtonProps> = ({
  courseId,
  advance,
  approved,
}) => {
  const history = useHistory()
  const t = useTranslationRankmi({
    prefix: 'components.courseCard',
  })
  const [loading, setLoading] = useState(false)

  const restart = async () => {
    setLoading(true)
    try {
      if (!courseId) return
      await restartCourse(courseId)
    } finally {
      setLoading(false)
    }
    history.push(`/courses/${courseId}`)
  }

  const canRestart = advance === MonitoringStatus.Finish && !approved

  if (!canRestart) return null

  return (
    <div className="d-flex justify-content-end mt-1">
      <Button
        size="sm"
        variant="outline-primary"
        onClick={(e) => {
          e.stopPropagation()
          restart()
        }}
      >
        {t('restart')}{' '}
        {loading && (
          <Spinner
            className="ml-2"
            size={'sm'}
            animation="border"
            role="status"
          />
        )}
      </Button>
    </div>
  )
}

export default RestartCourse